import React, {useEffect, useState} from "react";
import FileInput from "../../../../component/FileInput/FileInput";
import {ApiUrl} from "../../../../auth/authMethods";
import axios from "axios";
import LoadingButton from "@mui/lab/LoadingButton";
import CheckIcon from '@mui/icons-material/Check';


export default function SellerLogoForm({participanteId, setLoadData}) {
    const [imageFile, setImageFile] = useState([]);

    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    useEffect(() => {
        if (sent) {
            const timer = setTimeout(() => {
                setLoadData(true);
            }, 1 * 1000);

            return () => clearTimeout(timer);
        }
    }, [sent])

    const handleSendImage = (e) => {

        e.preventDefault()

        const formData = new FormData();
        formData.append("file", imageFile);

        setLoading(true)
        axios.post(`${ApiUrl}/seller-logo/${participanteId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(() => {
                setLoading(true)
                setSent(true)
            })
            .catch(() => {
            }).finally(() => setLoading(false))
    }

    return (
        <div className={"mt-4"}>

            <FileInput
                selectedFile={imageFile}
                setSelectedFile={setImageFile}
                accept={'image/*'}
            />


            {!sent ?
                <LoadingButton
                    onClick={handleSendImage}
                    loading={loading}
                    loadingPosition="start"
                    variant="contained"
                    color="primary"
                    disabled={!imageFile.name}
                >
                    Adicionar
                </LoadingButton>
                :
                <p className={'text-success'}>
                    <CheckIcon/> Imagem enviada com sucesso!
                </p>
            }
        </div>
    );
}
